/* eslint-disable @typescript-eslint/no-non-null-assertion */
export function combineElements<T>(arr: T[]): T[][] {
  const combinedArray: T[][] = [];

  for (let i = 0; i < arr.length; i += 2) {
    const subArray: T[] = [];
    if (arr[i]) {
      subArray.push(arr[i]!);
    }
    if (arr[i + 1]) {
      subArray.push(arr[i + 1]!);
    }
    combinedArray.push(subArray);
  }

  return combinedArray;
}
